import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import language, {languages} from '../constants/languages'
import { isEmpty } from 'lodash';
import { CONTACT_US } from '../constants/common'

const style = {
  footerStyle: {
	  backgroundColor: '#3e4152',
    justifyContent: 'space-around',
	  color: 'white',
    fontFamily: 'Open Sans'
  },
  footerHeader: {
	  fontSize: 18,
    fontWeight: 400,
  },
  footerDiv: {
	  marginLeft: "10%",
    marginRight: 25,
	  marginTop: 25,
  }
};

class Footer extends Component {

  render() {
    return (
      !isEmpty(this.props.selectedLanguage) && <div style={style.footerStyle}>
        <div style={{textAlign: 'center', paddingTop: 15}}>
          <div style={style.footerHeader}>{language[this.props.selectedLanguage].for_assistance}</div>
          <p style={style.footerHeader}> {language[this.props.selectedLanguage].call}: {CONTACT_US} | {language[this.props.selectedLanguage].email}: info@ascendcap.in</p>
        </div>
      <div id="wrapper">
        <div style={style.footerDiv}>
          <div style={style.footerHeader}>{language[this.props.selectedLanguage].company}</div>
          <div className="mt-10"><Link to="about_us" className="link">{language[this.props.selectedLanguage].about_us}</Link></div>
          <div className="mt-10"><HashLink to="about_us#team" className="link">{language[this.props.selectedLanguage].team}</HashLink></div>
          <div className="mt-10"><HashLink to="/#howItWorksId" className="link">{language[this.props.selectedLanguage].how_it_works}</HashLink></div>
        </div>
        <div style={style.footerDiv}>
          <div style={style.footerHeader}>{language[this.props.selectedLanguage].product}</div>
          <div className="mt-10"><HashLink to="products#lap" className="link">{language[this.props.selectedLanguage].lap}</HashLink></div>
          <div className="mt-10"><HashLink to="products#lap" className="link">{language[this.props.selectedLanguage].vehicle_loan}</HashLink></div>
        </div>
        <div style={style.footerDiv}>
          <div style={style.footerHeader}>{language[this.props.selectedLanguage].help}</div>
          <div className="mt-10"><Link to="contact" className="link">{language[this.props.selectedLanguage].contact_us}</Link></div>
          {/*<div className="mt-10"><Link to="products" className="link">FAQ's</Link></div>*/}
          <div className="mt-10"><Link to="privacy" className="link">{language[this.props.selectedLanguage].privacy_policy}</Link></div>
        </div>
        {/*
        <div style={style.footerDiv}>
          <div style={style.footerHeader}>Follow Us</div>
          <div className="social_icons_div">
            <Link target='_blank' to="https:facebook.com"><i className="fa fa-facebook"></i></Link>
            <Link target='_blank' style={{marginLeft: 8}} to="https:twitter.com"><i className="fa fa-twitter" /></Link>
            <Link target='_blank' style={{marginLeft: 8}} to="https:linkedin.com"><i className="fa fa-linkedin" /></Link>
          </div>
        </div>
        */}
      </div>
        <div style={{marginLeft: "10%",marginTop: 40, paddingBottom: 50}}>
          <div>@ 2018 LCGM Technologies Pvt. Ltd. All rights reserved.</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  selectedLanguage: state.defaultLanguage
});

const mapDispatchToProps = () => ({});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Footer));



// WEBPACK FOOTER //
// ./src/components/Footer.js